"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTime = exports.timestampLabel = exports.convertIsoDateAndHoursToLocalMomentDate = exports.convertMilitaryTimeToHourAndMinutes = exports.matchesIsoDate = exports.matchesMilitaryTime = exports.ONE_MONTH_IN_SECONDS = exports.ONE_WEEK_IN_SECONDS = exports.ONE_DAY_IN_SECONDS = void 0;
const moment = require("moment-timezone");
// helper constants storing time units in seconds
exports.ONE_DAY_IN_SECONDS = 86400;
exports.ONE_WEEK_IN_SECONDS = 604800;
exports.ONE_MONTH_IN_SECONDS = 2678400;
const matchesMilitaryTime = (militaryTime) => /^([01]\d|2[0-3]):?([0-5]\d)$/.test(militaryTime);
exports.matchesMilitaryTime = matchesMilitaryTime;
const matchesIsoDate = (isoDate) => /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/.test(isoDate);
exports.matchesIsoDate = matchesIsoDate;
const convertMilitaryTimeToHourAndMinutes = (militaryTime) => ({
    hour: parseInt(militaryTime.substring(0, 2), 10),
    minute: parseInt(militaryTime.substring(2, 4), 10)
});
exports.convertMilitaryTimeToHourAndMinutes = convertMilitaryTimeToHourAndMinutes;
const convertIsoDateAndHoursToLocalMomentDate = (date, militaryTime, timezone) => {
    if (!(0, exports.matchesIsoDate)(date)) {
        throw new Error(`must provide date in the iso format (eg 2021-04-06) - ${date} given`);
    }
    if (!(0, exports.matchesMilitaryTime)(militaryTime)) {
        throw new Error(`must provide military time in the format (eg. 0900) - ${militaryTime} given`);
    }
    const hour = militaryTime.substring(0, 2);
    const minute = militaryTime.substring(2, 4);
    return moment.tz(`${date} ${hour}:${minute}`, timezone);
};
exports.convertIsoDateAndHoursToLocalMomentDate = convertIsoDateAndHoursToLocalMomentDate;
/**
 * Human friendly label to show current time from given timestamp
 *
 * Examples:
 *  - in 1 hour
 *  - 33 minutes ago
 *  - 5 hours ago
 *  - 2 weeks ago
 */
function timestampLabel(timestamp, label) {
    if (timestamp === null) {
        return "";
    }
    const d1 = moment();
    const d2 = moment.unix(timestamp);
    if (d1.diff(d2) < 0) {
        const humanTime = moment.duration(d2.diff(d1)).humanize();
        label = label || "in";
        return `${label} ${humanTime}`;
    }
    const humanTime = moment.duration(d1.diff(d2)).humanize();
    label = label || "ago";
    return `${humanTime} ${label}`;
}
exports.timestampLabel = timestampLabel;
const toTime = (ts, timeZoneId, format) => {
    if (!ts) {
        return "-";
    }
    const momentDate = moment.unix(ts);
    if (timeZoneId) {
        momentDate.tz(timeZoneId);
    }
    return momentDate.format(format);
};
exports.toTime = toTime;
//# sourceMappingURL=time.js.map